import View from '../../../view.js';
import Modal from '../../modal';

namespace('IO.Views.Components.Rje', function (exports) {
  'use strict';

  var ManagementAPI = IO.Views.Components.Rje.Api.Management,
    Codes = IO.Views.Components.Rje.Codes,
    Management = View.extend({
      dom: {
        ENABLE_LINK: '.enable-link',
        DISABLE_LINK: '.disable-link',
        LINKS: '.state-links',
        STATE: '.state-text',
      },

      events: function () {
        var events = {};

        events['click ' + this.dom.ENABLE_LINK] = '_enable';
        events['click ' + this.dom.DISABLE_LINK] = '_disable';
        return events;
      },

      /*
        PUBLIC FUNCTIONS
      */
      initialize: function (options) {
        this.managementApi = new ManagementAPI({
          csrf: options.csrf,
        });
        this.name = options.name;
        this.poll = options.poll;
        this._attachEvents();
      },

      destroy: function () {
        this.stopListening();
        this.off();
      },

      /*
        PRIVATE FUNCTIONS
      */
      _attachEvents: function () {
        this.listenTo(
          this.managementApi,
          'enable:success',
          this._enableSuccessCallback,
        );
        this.listenTo(
          this.managementApi,
          'enable:fail',
          this._enableFailCallback,
        );
        this.listenTo(
          this.managementApi,
          'disable:success',
          this._disableSuccessCallback,
        );
        this.listenTo(
          this.managementApi,
          'disable:fail',
          this._disableFailCallback,
        );

        this.listenTo(this.poll, 'error', this._setUnknown);
        this.listenTo(this.poll, 'virtuals', this._processVirtuals); // virtuals
        // node
        this.listenTo(this.poll, this.name + ':puppet', this._setPuppetState);
        this.listenTo(
          this.poll,
          this.name + ':status',
          this._setPuppetStateByStatus,
        );
      },

      _processVirtuals: function (virtuals) {
        var virtual = virtuals[this.name];

        if (this.name === 'node') {
          return;
        }

        if (virtual) {
          this._setPuppetState(virtual.puppet);
          this._setPuppetStateByStatus(virtual.state);
        } else {
          this._setUnknown();
        }
      },

      _alert: function (args) {
        if (this.alert) {
          this.alert.close();
        }
        this.alert = new Alert(args);
        this.alert.prependTo('#main-content').show();
      },

      _enable: function (e) {
        var target = e.currentTarget,
          url = target.href;

        if ($(target).closest('.disabled').length) {
          return false;
        }

        this.$(this.dom.ENABLE_LINK).text('Enabling...').addClass('disabled');
        this.managementApi.enable(url);
        return false;
      },

      _enableSuccessCallback: function () {
        this._alert({
          message: 'Configuration enabled',
          type: 'success',
        });
        // this.poll.trigger(this.name + ':puppet', Codes.PUPPET_ENABLED_STOPPED)
        this._setEnabled();
      },

      _enableFailCallback: function (response) {
        console.log(response); // eslint-disable-line no-console
        this._error(response.responseText);
        this.$(this.dom.ENABLE_LINK).text('Enable').removeClass('disabled');
      },

      _disable: function (e) {
        var target = e.currentTarget,
          self = this,
          form;

        e.preventDefault();

        if ($(target).hasClass('disabled').length) {
          return false;
        }

        this.modal = new Modal({
          el: $(target).data('target'),
        });

        this.listenTo(this.modal, 'modalClosed', this._resetModal);

        form = this.modal.$el.find('form');

        form.on('submit', function (ev) {
          var reason;

          ev.preventDefault();

          reason = form.find('.reason');

          if (reason.val() === '') {
            if (form.find('.field_with_errors').length === 0) {
              reason
                .parent()
                .addClass('field_with_errors')
                .append('<small class="error">Can\'t be blank</small>');
            }
          } else {
            self._submitDisable(form.attr('action'), {
              reason: reason.val(),
            });
            self.modal.close();
          }
        });

        this.modal.show();
      },

      _submitDisable: function (url, data) {
        this.$(this.dom.DISABLE_LINK).text('disabling...').addClass('disabled');
        this.managementApi.disable(url, data);
      },

      _resetModal: function () {
        var form = this.modal.$el.find('form');

        form
          .find('.error-container')
          .removeClass('field_with_errors')
          .find('small')
          .remove();

        form.find('#reason').val('');

        form.off();
      },

      _disableSuccessCallback: function () {
        this._alert({
          message: 'Configuration disabled',
          type: 'success',
        });
        // this.poll.trigger(this.name + ':puppet', Codes.PUPPET_DISABLED)
        this._setDisabled();
      },

      _disableFailCallback: function (response) {
        this._error(response.responseText);
        this.$(this.dom.DISABLE_LINK).text('Disable').removeClass('disabled');
      },

      // after receiving state
      _setPuppetState: function (state) {
        this.puppetState = state;
      },

      _setPuppetStateByStatus: function (status) {
        if (status === Codes.STATE_RUNNING || status === 'online') {
          switch (this.puppetState) {
            case Codes.PUPPET_DISABLED:
              this._setDisabled();
              break;
            case Codes.PUPPET_ENABLED_STOPPED:
            case Codes.PUPPET_ENABLED_RUNNING:
              this._setEnabled();
              break;
            default:
              this._setUnknown();
              break;
          }
        } else {
          this._setUnableToReach();
        }
      },

      _setDisabled: function () {
        this.$(this.dom.LINKS).removeClass('hide');
        this.$(this.dom.STATE).text('Disabled');
        this.$(this.dom.ENABLE_LINK).removeClass('hide disable');
        this.$(this.dom.DISABLE_LINK)
          .text('Disable')
          .removeClass('disabled')
          .addClass('hide');
      },

      _setEnabled: function () {
        this.$(this.dom.LINKS).removeClass('hide');
        this.$(this.dom.STATE).text('Active');
        this.$(this.dom.DISABLE_LINK).removeClass('hide disable');
        this.$(this.dom.ENABLE_LINK)
          .text('Enable')
          .removeClass('disabled')
          .addClass('hide');
      },

      _setUnableToReach: function () {
        this.$(this.dom.STATE).text('-');
        this.$(this.dom.LINKS).addClass('hide');
      },

      _setUnknown: function () {
        this.$(this.dom.STATE).text('Unknown');
        this.$(this.dom.LINKS).addClass('hide');
      },

      _error: function (msg) {
        this._alert({
          message: msg || 'An error occurred. Please contact support.',
          type: 'alert',
        });
      },
    });

  exports.Management = Management;
});
